<template>
  <auth-layout>
    <div class="centered unauthorized-container">
      <h1>Unauthorized</h1>
      <h4>You are not authorized to view this page.</h4>
      <router-link to="/login"><h4>Go to Login Page</h4></router-link>
    </div>
  </auth-layout>
</template>

<script>
import AuthLayout from "@/components/AuthLayout.vue";

export default {
  name: "UnauthorizedPage",
  components: { AuthLayout },
};
</script>

<style scoped>
.unauthorized-container {
  text-align: center;
  color: white;
}
</style>
